// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"zp-z","breadcrumbForward":"Ap-z","breadcrumbBack":"Bp-z","selected":"Cp-z"};